// import React from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';
// import 'swiper/css/autoplay';
// import { Autoplay } from 'swiper/modules';

// // Shapes & Background Images
// import dot from '../img/shape/Dot.png';
// import circle from '../img/shape/circle1.png';
// import bg from '../img/shape/Bg.png';

// // Logo brand colors
// const brandOrange = "#f15a29";   // pick from logo
// const brandBlue = "#0a2a55";     // pick from logo

// // Images from public folder
// const tourImages = [
//   '/images/gallery/1.jpg',
//   '/images/gallery/2.jpg',
//   '/images/gallery/3.jpg',
//   '/images/gallery/4.jpg',
//   '/images/gallery/19.jpg',
//   '/images/gallery/20.jpg',
//   '/images/gallery/14.jpeg',

// ];

// // Tour data
// const tourData = [
//   { title: "SWIFT DZIRE", location: "Pune Maharashtra", days: 4, people: 3, price: "$399", stars: 5 },
//   { title: "ERTIGA", location: "Pune Maharashtra", days: 7, people: 3, price: "$259", stars: 5 },
//   { title: "INNOVA CRYSTA", location: "Pune Maharashtra", days: 7, people: 3, price: "$299", stars: 5 },
//   { title: "TEMPO TRAVELLER", location: "Pune Maharashtra", days: 17, people: 3, price: "$299", stars: 5 },
//   { title: "Scorpio", location: "Pune Maharashtra", days: 8, people: 2, price: "$199", stars: 5 },
//   { title: "Tavera", location: "Pune Maharashtra", days: 8, people: 2, price: "$199", stars: 5 },
//   { title: "Cruiser", location: "Pune Maharashtra", days: 13, people: 2, price: "$199", stars: 5 },

// ];

// // Combine tour data and images
// const tours = tourData.map((tour, idx) => ({
//   ...tour,
//   image: tourImages[idx]
// }));

// // Star rating component
// const StarRating = ({ count }) => (
//   <div className="package-review" style={{ color: brandOrange, textAlign: "center" }}>
//     {[...Array(5)].map((_, i) => (
//       <i key={i} className={i < count ? 'fas fa-star' : 'far fa-star'}></i>
//     ))}
//   </div>
// );

// const TourPackages = () => {
//   return (
//     <section className=" py-md-3 shape-mockup-wrap" style={{ backgroundImage: `url(${bg})`, backgroundColor: "#f9fbff" }}>
//       {/* Decorative Shapes */}
//       <div className="shape-mockup d-none d-xl-block jump z-index-negative" style={{ bottom: '20%', left: '5%' }}>
//         <img src={dot} alt="Decorative Dots" />
//       </div>
//       <div className="shape-mockup d-none d-xl-block spin z-index-negative" style={{ bottom: '-5%', right: '-5%' }}>
//         <img src={circle} alt="Decorative Circle" />
//       </div>

//       <div className="container">
//         {/* Heading Section */}
//         <div className="row justify-content-center text-center">
//           <div className="col-xl-6 col-lg-8 wow fadeInUp" data-wow-delay="0.3s">
//             <div className="title-area">
//               <span className="sec-subtitle" style={{ color: brandOrange }}>Our Fleet & Services</span>
//               <h2 className="sec-title h1" style={{ color: brandBlue }}>Book Your Perfect Ride</h2>
//             </div>
//           </div>
//         </div>

//         {/* Swiper Slider */}
//         <Swiper
//           modules={[Autoplay]}
//           spaceBetween={20}
//           slidesPerView={4}
//           centeredSlides={true}   // keeps slides centered
//           loop={true}
//           speed={90000}            // smooth continuous speed (ms)
//           autoplay={{
//             delay: 0,             // no pause between slides
//             disableOnInteraction: false
//           }}
//           breakpoints={{
//             320: { slidesPerView: 1 },
//             576: { slidesPerView: 2 },
//             992: { slidesPerView: 3 },
//             1200: { slidesPerView: 4 }
//           }}
//           className="d-flex justify-content-center"
//         >
//           {tours.map((tour, index) => (
//             <SwiperSlide key={index}>
//               <div className="package-style1" style={{
//                 border: `2px solid ${brandBlue}`,
//                 borderRadius: "12px",
//                 overflow: "hidden",
//                 textAlign: "center"
//               }}>
//                 <div className="package-img">
//                   <a href="/booking">
//                     <img className="w-100" src={tour.image} alt={tour.title} />
//                   </a>
//                 </div>
//                 <div className="package-content" style={{ padding: "15px", background: "#fff" }}>
//                   <StarRating count={tour.stars} />
//                   <h3 className="package-title">
//                     <a href="/booking" style={{ color: brandBlue }}>{tour.title}</a>
//                   </h3>
//                   <p className="package-text" style={{ color: "#444" }}>{tour.location}</p>
//                   <div className="package-meta" style={{ color: brandBlue }}>
//                     <i className="fas fa-car"></i> Seater: {tour.days}
//                   </div>
//                   <div className="package-footer text-center" style={{ marginTop: "10px" }}>
//                     <a href="/booking" className="vs-btn" style={{
//                       backgroundColor: brandOrange,
//                       color: "#fff",
//                       padding: "8px 16px",
//                       borderRadius: "6px",
//                       textDecoration: "none",
//                       fontWeight: "bold"
//                     }}>Book Now</a>
//                   </div>
//                 </div>
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>
//     </section>
//   );
// };

// export default TourPackages;


import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';


const tourImages = [
  '/images/gallery/1.jpg',
  '/images/gallery/2.jpg',
  '/images/gallery/3.jpg',
  '/images/gallery/4.jpg',
  '/images/gallery/19.jpg',
  '/images/gallery/20.jpg',
  '/images/gallery/14.jpeg',
];

const tourData = [
  { title: "SWIFT DZIRE", location: "Pune Maharashtra", seater: 4, stars: 5 },
  { title: "ERTIGA", location: "Pune Maharashtra", seater: 7, stars: 5 },
  { title: "INNOVA CRYSTA", location: "Pune Maharashtra", seater: 7, stars: 5 },
  { title: "TEMPO TRAVELLER", location: "Pune Maharashtra", seater: 17, stars: 5 },
  { title: "SCORPIO", location: "Pune Maharashtra", seater: 7, stars: 5 },
  { title: "TAVERA", location: "Pune Maharashtra", seater: 8, stars: 5 },
  { title: "CRUISER", location: "Pune Maharashtra", seater: 13, stars: 5 },
];

const tours = tourData.map((tour, idx) => ({
  ...tour,
  image: tourImages[idx]
}));

const StarRating = ({ count }) => (
  <div className="tour-stars">
    {[...Array(5)].map((_, i) => (
      <i key={i} className={i < count ? 'fas fa-star' : 'far fa-star'}></i>
    ))}
  </div>
);

const TourPackages = () => {
  return (
    <section className="tour-section">
      <div className="container">
        <div className="text-center">
          <h2 className="tour-heading">Book Your Perfect Ride</h2>
        </div>

        <Swiper
          modules={[Autoplay]}
          spaceBetween={20}
          slidesPerView={4}
          loop={true}
          speed={90000}
          autoplay={{
            delay: 0,
            disableOnInteraction: false
          }}
          breakpoints={{
            320: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
            1200: { slidesPerView: 4 }
          }}
        >
          {tours.map((tour, index) => (
            <SwiperSlide key={index}>
              <div className="tour-card">
                <img src={tour.image} alt={tour.title} className="tour-image" />
                <StarRating count={tour.stars} />
                <h3 className="tour-title">{tour.title}</h3>
                <p className="tour-location">{tour.location}</p>
                <p className="tour-seater">🚐 Seater: {tour.seater}</p>
                <a href="/booking" className="tour-btn">Book Now</a>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TourPackages;
